import "./nosotros.scss";


export default function Nosotros() {

    return (
        <div className="nosotros" id="nosotros">

            <h1 className="titulo">¿QUIENES SOMOS?</h1>

            <p className="descripcion">
                En <b>J&G Agrimensura y Topografía</b> somos un equipo de profesionales conformado por los <b>Ingenieros Agrimensores Gonzalo Piñeiro y Juan Ignacio Vaccaiani</b>, graduados de la <b>Universidad de Buenos Aires (UBA)</b>, dedicados a brindar soluciones integrales en servicios de agrimensura y topografía. <br /><br />Nuestro trabajo se basa en la <b>precisión, la responsabilidad y el compromiso</b> con cada proyecto. Brindamos soluciones profesionales a particulares, como escribanos, abogados, propietarios de inmuebles, estudios de arquitectura e ingeniería, empresas constructoras, así como también a entidades públicas. <br /><br />Acompañamos a nuestros clientes en cada etapa, ofreciendo soluciones a medida y transformando ideas en realidad con nuestra <b>experiencia, tecnología avanzada, precisión y eficiencia.</b><br /><br />Conocé mas sobre nuestro trabajo y descubrí cómo podemos ayudarte en tu próximo proyecto.
            </p>


            <h2 className="titulo2">NOSOTROS</h2>

            <div className="equipo">
                <div className="persona">
                    <div className="circulo">
                        <img src="assets/img/gonzalo.png" alt="" />
                    </div>
                    <div className="infoPersona">
                        <h3>GONZALO PIÑEIRO</h3>
                        <p>INGENIERO AGRIMENSOR</p>
                        <p>Matricula C.P.A. 2952 - Distrito X</p>
                        <p>Matricula C.P.A.J.N. 3654</p>
                        <p>+54 11 3599-3339</p>
                        <p>jyg.agrimensura@gmail.com</p>
                    </div>
                </div>
                <div className="persona">
                    <div className="circulo">
                        <img src="assets/img/juan.png" alt="" />
                    </div>
                    <div className="infoPersona">
                        <h3>JUAN IGNACIO VACCAIANI</h3>
                        <p>INGENIERO AGRIMENSOR</p>
                        <p>Matricula C.P.A. 3008 - Distrito X</p>
                        <p>+54 3487 406528</p>
                        <p>jyg.agrimensura@gmail.com</p>
                    </div>
                </div>
            </div>

            <div className="ubicacion">
                <img src="assets/img/ubicacion2.png" alt="" className="ubicacion-img" />
                <div className="ubicacion-txt">
                    <h1>AREAS DE COBERTURA</h1>
                    <p>Provincia de Buenos Aires y CABA</p>
                </div>
            </div>

            <div className="ubicacion2">

                <h1>AREAS DE COBERTURA</h1>
                <img src="assets/img/ubicacion2.png" alt="" className="ubicacion-img2" />
                <p>Provincia de Buenos Aires y CABA</p>

            </div>


        </div>
    );
}